module.exports = __webpack_public_path__ + "img/ic24TDelete.4061b145.svg";